import { PlusOutlined } from "@ant-design/icons"
import { Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface CreateFolderRowProps {
  onClick: () => void
}

/** The list view's counterpart to CreateFolderCard, shaped like the Albums list's create row. */
export function CreateFolderRow({ onClick }: CreateFolderRowProps) {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={onClick}
      className="flex w-full items-center gap-3 rounded-md border border-dashed border-border bg-transparent px-3 py-2 text-left cursor-pointer hover:border-primary"
    >
      <PlusOutlined className="text-primary" />
      <Text strong>{t("files.folder.createCard.title")}</Text>
    </button>
  )
}
